export default __webpack_public_path__ + "static/media/design.17b2cd22.svg";